import { render, staticRenderFns } from "./ConfigureMailTemplateDlg.vue?vue&type=template&id=278e0043&scoped=true"
import script from "./ConfigureMailTemplateDlg.vue?vue&type=script&lang=js"
export * from "./ConfigureMailTemplateDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e0043",
  null
  
)

export default component.exports